import React, { useContext } from 'react'

import { DataContext } from './DataContext'
import NoDataComponent from '../../../elem/table/client/NoDataComponent'
import TableContent from '../../../elem/table/client/TableContent'
import parseColumns from '../../../../utils/table/parseColumns'
import withConfig from '../../../wrappers/withConfig'

export default withConfig(({ config }) => {
    const { detailData, filterData, visibleDetailTab, isLoading } = useContext(DataContext)
    const { ID_COLUMN, EXPLORER_LINK_COLUMN } = config
    if (
            detailData &&
            detailData.construction &&
            filterData &&
            filterData.construction &&
            visibleDetailTab === 'construction'
    ) {
        const formFields = filterData.construction
        const constructionDetailsData = detailData.construction
        const columns = parseColumns(constructionDetailsData, formFields, EXPLORER_LINK_COLUMN, ID_COLUMN)
        return (
            <div className="is-size-7 detailTableWrapper screenDetailWrapper">
                <NoDataComponent data={constructionDetailsData} isLoading={isLoading} />
                <TableContent
                    name="constructionDetails"
                    columns={columns}
                    data={constructionDetailsData}
                    loading={isLoading}
                    initialSort={null}
                    initialSortDesc={false}
                />
            </div>
        )

    } else {
        return null
    }
})